import { render, staticRenderFns } from "./JobsView.vue?vue&type=template&id=2990cbc6"
import script from "./JobsView.vue?vue&type=script&lang=ts"
export * from "./JobsView.vue?vue&type=script&lang=ts"
import style0 from "./JobsView.vue?vue&type=style&index=0&id=2990cbc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports